angular.module('impactx.login').controller('LoginChooseExternalCtrl', [
    '$mdDialog',
    '$routeParams',
    LoginChooseExternalController]);

function LoginChooseExternalController($mdDialog, $routeParams) {
    $mdDialog.show({
        templateUrl: 'modules/login/templates/login.choose-external-dialog.tmpl.html',
        controller: 'LoginChooseExternalDialogCtrl',
        controllerAs: "loginChooseExternalDialogCtrl",
        clickOutsideToClose: false,
        escapeToClose: false,
        fullscreen: false,
        locals: {
            osuTan: $routeParams.osuTan
        },
        bindToController: true
    });
}